<template>
    <!-- 검색 바./.. -->
    <div class="gmx_empty_container flex flex_column flex_center_3">
        <div class="gmx_cha_ani">
          <svg xmlns="http://www.w3.org/2000/svg" width="198px"
            height="81px" viewBox="0 0 600 231.229">
            <g>
                <path fill="#4a4949" stroke-width="0"
                    d="m328.993,157.057c-26.686-21.477-40.217-36.753-40.217-112.708v-.842h29.857c3.062,0,4.963-1.825,4.963-4.762v-17.61c0-2.937-1.901-4.762-4.963-4.762h-91.652c-2.937,0-4.762,1.825-4.762,4.762v17.61c0,2.937,1.825,4.762,4.762,4.762h32.059v.842c0,57.331-3.602,69.861-10.705,81.875-7.17,12.12-17.298,23.435-30.106,33.631-1.186.945-1.812,2.222-1.812,3.688,0,1.863.746,2.95,1.452,3.56l12.185,13.976c.936.939,2.088,1.435,3.332,1.435,1.431,0,2.691-.428,3.715-1.245,8.618-6.596,16.47-14.006,23.34-22.024,5.805-6.769,10.567-13.514,14.196-20.097,3.265,5.703,7.611,11.647,12.959,17.72,6.453,7.328,14.08,14.582,22.682,21.57,2.169,1.739,5.161,1.783,7.193-.279l11.902-13.892c1.08-1.089,1.629-2.272,1.629-3.524,0-1.517-.768-2.867-2.009-3.686Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m371.856,9.407h-20.209c-2.939,0-4.764,1.825-4.764,4.762v170.899c0,2.815,1.825,4.562,4.764,4.562h20.209c3.659,0,4.963-2.357,4.963-4.562V14.17c0-2.937-1.901-4.762-4.963-4.762Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m444.25,129.237c0,2.205,1.304,4.562,4.963,4.562h20.011c2.815,0,4.562-1.747,4.562-4.562v-19.587c16.331-1.095,31.624-3.015,45.552-5.724,3.722-.857,4.277-3.066,4.277-4.306l-2.237-16.397c-.454-2.49-2.072-3.975-4.325-3.975h-.802l-.376.034c-20.184,3.564-46.721,5.37-78.868,5.37h-31.818c-2.937,0-4.762,1.825-4.762,4.762v16.409c0,2.815,1.825,4.562,4.762,4.562h39.062v18.853Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m556.874,161.895h-95.495v-20.251c0-1.597-.789-2.91-2.23-3.701-1.055-.572-2.243-.861-3.532-.861h-19.412c-2.937,0-4.762,1.747-4.762,4.562v42.623c0,2.937,1.825,4.762,4.762,4.762h120.669c3.062,0,4.963-1.825,4.963-4.762v-17.409c0-3.062-1.901-4.963-4.963-4.963Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m491.882,114.104c-.814.819-1.228,2.004-1.228,3.526v14.808c0,1.521.414,2.707,1.236,3.534.819.814,2.004,1.228,3.526,1.228h35.661v8.845c0,2.937,1.825,4.762,4.762,4.762h20.211c3.062,0,4.963-1.825,4.963-4.762V14.17c0-2.937-1.901-4.762-4.963-4.762h-20.211c-2.937,0-4.762,1.825-4.762,4.762v98.698h-35.661c-1.521,0-2.707.414-3.534,1.236Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m424.955,72.968c8.467,5.973,20.669,9.001,36.266,9.001,15.726,0,27.963-3.03,36.372-9.005,8.636-6.136,13.014-14.47,13.014-24.773,0-10.432-4.378-18.836-13.014-24.976-8.412-5.973-20.648-9.003-36.372-9.003-15.593,0-27.795,3.028-36.266,8.999-8.708,6.138-13.122,14.542-13.122,24.98,0,10.307,4.414,18.644,13.122,24.777Zm20.838-31.814c3.452-1.998,8.642-3.011,15.428-3.011s12.016,1.017,15.542,3.019c3.169,1.804,4.709,4.102,4.709,7.028,0,2.789-1.54,5.022-4.709,6.826-3.526,2.002-8.754,3.019-15.542,3.019s-11.976-1.013-15.428-3.011c-3.112-1.802-4.625-4.036-4.625-6.834,0-2.933,1.513-5.235,4.625-7.037Z" />
                <g class="body">
                  <path fill="#377ef9" stroke-width="0"
                    d="m145.499,135.535c-26.952,30.584-62.994,23.261-81.625,10.846-2.276-1.517-2.088-4.916.348-6.162l126.624-64.739c1.513-.774,2.296-2.515,1.813-4.144C182.526,37.131,154.299,9.521,116.893,1.981,71.856-7.098,27.816,15.797,8.234,55.025c-1.047,2.098.203,4.624,2.502,5.087l31.864,6.423c1.365.275,2.752-.285,3.586-1.4,26.629-35.582,65.632-26.83,85.039-13.316,2.234,1.556,2.027,4.917-.404,6.143L3.251,122.239c-1.508.76-2.303,2.48-1.846,4.107,9.781,34.83,38.263,63.071,76.162,70.711,43.313,8.731,85.701-12.112,106.303-48.613,1.143-2.025.056-4.587-2.19-5.189-6.905-1.85-20.805-5.59-32.522-8.84-1.335-.37-2.744.08-3.659,1.119Z" />
                  <path fill="#f5b91f" stroke-width="0"
                    d="m4.84,110.175l36.812-17.525c1.247-.594,1.966-1.911,1.787-3.281-.269-2.069-.51-5.393-.067-9.237.2-1.739-.977-3.334-2.71-3.577l-32.133-4.498c-1.434-.201-2.831.586-3.379,1.925-2.026,4.953-6.294,17.615-4.863,33.605.197,2.204,2.554,3.538,4.552,2.587Z" />
                    <g class="eye">
                    <ellipse fill="#ffffff" stroke="#231815" stroke-miterlimit="10" stroke-width="5px" cx="57.172" cy="74.15" rx="23.863" ry="29.6" />
                    <path class="move" fill="#231815"
                        d="m67.911,53.506c-5.975,0-11.104,5.363-13.324,13.02,3.238,1.557,5.479,4.859,5.479,8.693,0,3.792-2.192,7.064-5.374,8.642,2.273,7.471,7.335,12.674,13.219,12.674,8.008,0,14.5-9.632,14.5-21.514s-6.492-21.514-14.5-21.514Z" />
                  </g>
                  <g class="eye">
                      <ellipse fill="#ffffff" stroke="#231815" stroke-miterlimit="10" stroke-width="5px" cx="137.479" cy="74.15" rx="23.863" ry="29.6" />
                      <path class="move" fill="#231815"
                          d="m148.219,53.506c-5.975,0-11.104,5.363-13.324,13.02,3.238,1.557,5.479,4.859,5.479,8.693,0,3.792-2.192,7.064-5.374,8.642,2.273,7.471,7.335,12.674,13.219,12.674,8.008,0,14.5-9.632,14.5-21.514s-6.492-21.514-14.5-21.514Z" />
                  </g>
                </g>
                <rect class="under" fill="#377ef9" stroke-width="0"  x="10.037" y="215.254" width="176.617" height="9.885" rx="2.504" ry="2.504" />
                <path fill="#4a4949" stroke-width="0"
                    d="m228.41,211.099c-2.932-.03-4.957,1.602-4.957,3.869,0,2.206,2.205,3.234,4.23,3.808l2.237.605c2.659.755,5.834,2.176,5.864,5.803-.03,3.416-2.811,6.044-7.495,6.044-4.414,0-7.195-2.327-7.437-5.743h2.177c.182,2.479,2.449,3.839,5.26,3.808,3.142.03,5.44-1.662,5.44-4.171,0-2.147-1.844-3.114-4.412-3.869l-2.601-.726c-3.323-.998-5.288-2.72-5.318-5.5.03-3.476,3.083-5.834,7.071-5.864,4.02.03,6.861,2.418,7.013,5.682h-2.056c-.21-2.327-2.235-3.778-5.015-3.748Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m263.535,209.466v14.146c-.03,4.413-3.326,7.616-8.162,7.616-4.866,0-8.162-3.234-8.162-7.616v-14.146h2.116v14.025c-.03,3.325,2.359,5.773,6.046,5.743,3.657.03,6.015-2.418,6.046-5.743v-14.025h2.116Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m275.931,209.466h7.013c4.594.03,6.922,2.902,6.952,6.65-.03,3.778-2.359,6.68-6.952,6.649h-4.897v8.1h-2.116v-21.4Zm6.952,11.426c3.326,0,4.927-2.025,4.897-4.775.03-2.751-1.571-4.746-4.957-4.716h-4.775v9.491h4.836Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m301.202,209.466h7.013c4.594.03,6.922,2.902,6.952,6.65-.03,3.778-2.359,6.68-6.952,6.649h-4.897v8.1h-2.116v-21.4Zm6.952,11.426c3.326,0,4.927-2.025,4.897-4.775.03-2.751-1.571-4.746-4.957-4.716h-4.775v9.491h4.836Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m334.819,231.168c-5.442,0-9.281-4.292-9.311-11.002.03-6.68,3.899-10.971,9.311-10.941,5.409-.03,9.278,4.262,9.309,10.941-.03,6.71-3.899,11.002-9.309,11.002Zm0-1.995c4.139,0,7.253-3.294,7.253-9.007,0-5.682-3.114-9.007-7.253-9.007s-7.225,3.325-7.255,9.007c.03,5.682,3.114,9.007,7.255,9.007Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m355.554,209.466h7.013c4.594.03,6.922,2.691,6.952,6.469-.03,2.871-1.391,5.077-4.081,5.955l4.927,8.976h-2.417l-4.657-8.614c-.24.03-.482.03-.725.03h-4.897v8.584h-2.116v-21.4Zm6.952,10.942c3.326-.03,4.927-1.723,4.897-4.474.03-2.75-1.571-4.565-4.957-4.534h-4.775v9.008h4.836Z" />
                <path fill="#4a4949"  d="m379.742,209.466h15.597v1.934h-6.71v19.465h-2.116v-19.465h-6.77v-1.934Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m420.369,211.099c-2.932-.03-4.957,1.602-4.957,3.869,0,2.206,2.205,3.234,4.23,3.808l2.237.605c2.659.755,5.834,2.176,5.864,5.803-.03,3.416-2.811,6.044-7.495,6.044-4.414,0-7.195-2.327-7.437-5.743h2.177c.182,2.479,2.449,3.839,5.26,3.808,3.142.03,5.44-1.662,5.44-4.171,0-2.147-1.844-3.114-4.412-3.869l-2.601-.726c-3.323-.998-5.288-2.72-5.318-5.5.03-3.476,3.083-5.834,7.071-5.864,4.02.03,6.861,2.418,7.013,5.682h-2.056c-.21-2.327-2.235-3.778-5.015-3.748Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m439.594,209.466l6.286,10.095h.182l6.227-10.095h2.417l-7.677,12.272v9.128h-2.116v-9.128l-7.738-12.272h2.419Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m471.759,211.099c-2.932-.03-4.957,1.602-4.957,3.869,0,2.206,2.205,3.234,4.23,3.808l2.237.605c2.659.755,5.834,2.176,5.864,5.803-.03,3.416-2.811,6.044-7.495,6.044-4.414,0-7.195-2.327-7.437-5.743h2.177c.182,2.479,2.449,3.839,5.26,3.808,3.142.03,5.44-1.662,5.44-4.171,0-2.147-1.844-3.114-4.412-3.869l-2.601-.726c-3.323-.998-5.288-2.72-5.318-5.5.03-3.476,3.083-5.834,7.071-5.864,4.02.03,6.861,2.418,7.013,5.682h-2.056c-.21-2.327-2.235-3.778-5.015-3.748Z" />
                <path fill="#4a4949"  d="m489.292,209.466h15.597v1.934h-6.712v19.465h-2.114v-19.465h-6.77v-1.934Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m516.015,209.466h12.513v1.934h-10.397v7.859h9.733v1.813h-9.733v7.919h10.579v1.874h-12.695v-21.4Z" />
                <path fill="#4a4949" stroke-width="0"
                    d="m542.799,209.466l7.616,18.377h.182l7.677-18.377h2.417v21.4h-1.995v-17.047h-.179l-7.073,17.047h-1.874l-7.073-17.047h-.182v17.047h-1.995v-21.4h2.48Z" />
            </g>
        </svg>
        </div>
        <span>{{ EMPTY_DATA }}</span>
    </div>
    
  </template>
  
  <script setup>
  import { EMPTY_DATA } from '@/js/lang.js';
  </script>
  
  <!-- 바꾸셔도 됩니당. -->
  <style scoped lang="scss">
    .gmx_empty_container {
      margin:40px 0;
      svg {
        opacity: 1;
        * {
          transform-box: fill-box;
        }
      }

      .eye {
        transform: scaleY(0);
        transform-origin: center center;
        animation: eyes 0.5s 2 forwards;
        animation-delay: 3.5s;
        @keyframes eyes {
          from {
            transform: scaleY(0);
          }
          to {
            transform: scaleY(1);
          }
        }
        .move {
          animation: move 5s 1 forwards;
          animation-delay: 4.5s;
          @keyframes move {
            0%, 50%, 100% {
              transform: translateX(0);
            }
            25%, 75% {
              transform: translateX(-60%);
            }
          }
        }
      }
      .body {
        transform: translateY(120%) scaleY(0);
        transform-origin: center center;
        animation: body 0.5s 1 forwards cubic-bezier(0.175, 0.885, 0.32, 1.275);
        animation-delay: 2s;
        @keyframes body {
          0% {
            transform: translateY(120%) scaleY(0);
          }
          100% {
            transform: translateY(0) scaleY(1);
          }
        }
      }
      .under {
        transform: scaleX(0);
        transform-origin: center center;
        animation: under 1s 1 forwards;
        @keyframes under {
          0% {
            transform: scaleX(0);
          }
          100% {
            transform: scaleX(1);
          }
        }
      }
      > span {
        margin-top: 15px;
        font-size: $font-size4;
        font-family: $font-type2;
        color: $gmx-font-sub-color2;
      }
    }
  </style>